import WebFont from 'webfontloader';

if (!window.WebFont) {
  window.WebFont = WebFont;
}
